module.exports = __webpack_public_path__ + "img/zhuan1.adf27e49.png";